import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

const IOS = {
  purple:'#5E5CE6', orange:'#FF9500', blue:'#007AFF',
  green:'#34C759', teal:'#5AC8FA',
};

const imagenes = [
  '/imagenes/imagen1.png',
  '/imagenes/imagen2.png',
  '/imagenes/imagen3.png',
  '/imagenes/imagen4.png',
];

const EnConstruccion = () => {
  const navigate  = useNavigate();
  const user      = authService.getCurrentUser();
  const [bgImg,   setBgImg]   = useState('');
  const [dots,    setDots]    = useState(1);

  useEffect(() => {
    setBgImg(imagenes[Math.floor(Math.random() * imagenes.length)]);
  }, []);

  // Animación de puntos "..."
  useEffect(() => {
    const t = setInterval(() => setDots(d => d >= 3 ? 1 : d + 1), 600);
    return () => clearInterval(t);
  }, []);

  return (
    <Box sx={{
      minHeight:'100vh', width:'100vw', position:'relative',
      backgroundImage:`url(${bgImg})`,
      backgroundSize:'cover', backgroundPosition:'center', backgroundRepeat:'no-repeat',
      display:'flex', alignItems:'center',
      justifyContent:{ xs:'center', md:'flex-start' },
      pl:{ xs:0, md:'6vw' }, px:{ xs:2, sm:0 },
    }}>
      {/* Overlay */}
      <Box sx={{
        position:'absolute', inset:0, zIndex:1,
        background:{
          xs:'rgba(0,0,0,0.60)',
          md:'linear-gradient(105deg, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.52) 45%, rgba(0,0,0,0.15) 100%)'
        }
      }} />

      {/* Contenido */}
      <Box sx={{ position:'relative', zIndex:2, width:{ xs:'100%', sm:480 }, maxWidth:{ xs:'100%', sm:480 } }}>

        {/* Logo */}
        <Box sx={{ mb:5 }}>
          <img src="/imagenes/logo-integra.png" alt="integra"
            style={{ height:32, display:'block', opacity:0.9 }}
            onError={e=>e.target.style.display='none'} />
        </Box>

        {/* Ícono animado */}
        <Box sx={{ mb:4, display:'flex', alignItems:'center', gap:2 }}>
          <Box sx={{
            width:64, height:64, borderRadius:'18px',
            background:`linear-gradient(135deg, ${IOS.orange}30, ${IOS.orange}10)`,
            border:`1.5px solid ${IOS.orange}40`,
            display:'flex', alignItems:'center', justifyContent:'center',
            animation:'float 3s ease-in-out infinite',
            '@keyframes float':{ '0%,100%':{ transform:'translateY(0)' }, '50%':{ transform:'translateY(-8px)' } }
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="1.6" strokeLinecap="round">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
            </svg>
          </Box>
          {/* Barras de progreso animadas */}
          <Box sx={{ flex:1 }}>
            {[100, 75, 55].map((w,i)=>(
              <Box key={i} sx={{ mb:i<2?0.8:0, height:6, borderRadius:20,
                bgcolor:'rgba(255,255,255,0.08)', overflow:'hidden' }}>
                <Box sx={{
                  height:'100%', borderRadius:20,
                  background:i===0?IOS.orange:i===1?IOS.purple:IOS.teal,
                  width:`${w}%`, opacity:0.7,
                  animation:`progress${i} ${2+i*0.4}s ease-in-out infinite`,
                  [`@keyframes progress${i}`]:{ '0%,100%':{ width:`${w}%` }, '50%':{ width:`${Math.min(w+15,100)}%` } }
                }} />
              </Box>
            ))}
          </Box>
        </Box>

        {/* Título */}
        <Box sx={{ mb:3 }}>
          <Typography sx={{
            fontSize:{ xs:'2.6rem', sm:'3.2rem' }, fontWeight:800,
            color:'white', lineHeight:1.1, letterSpacing:'-0.04em'
          }}>
            En
          </Typography>
          <Typography sx={{
            fontSize:{ xs:'2.6rem', sm:'3.2rem' }, fontWeight:800,
            color:IOS.orange, lineHeight:1.1, letterSpacing:'-0.04em'
          }}>
            construcción.
          </Typography>
          <Typography sx={{ fontSize:'1rem', color:'rgba(255,255,255,0.5)', mt:1.5, fontWeight:400, lineHeight:1.6 }}>
            Estamos trabajando duro para traerte esta funcionalidad
            <span style={{ color:IOS.orange }}>{'·'.repeat(dots)}</span>
          </Typography>
        </Box>

        {/* Info módulo */}
        <Box sx={{
          p:2, mb:4, borderRadius:'14px',
          bgcolor:'rgba(255,255,255,0.05)',
          border:'1px solid rgba(255,255,255,0.1)',
          backdropFilter:'blur(8px)',
          display:'flex', alignItems:'center', gap:1.5
        }}>
          <Box sx={{ width:8, height:8, borderRadius:'50%', bgcolor:IOS.orange,
            animation:'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse':{ '0%,100%':{ opacity:1, transform:'scale(1)' }, '50%':{ opacity:0.4, transform:'scale(0.8)' } }
          }} />
          <Typography sx={{ fontSize:'0.82rem', color:'rgba(255,255,255,0.6)', fontWeight:500 }}>
            Módulo en desarrollo activo — próximamente disponible
          </Typography>
        </Box>

        {/* Botones */}
        <Box sx={{ display:'flex', gap:1.5, flexWrap:'wrap' }}>
          <Box component="button" onClick={()=>navigate(-1)}
            sx={{
              height:46, px:3, borderRadius:'12px', border:'1.5px solid rgba(255,255,255,0.2)',
              bgcolor:'rgba(255,255,255,0.08)', cursor:'pointer', backdropFilter:'blur(8px)',
              display:'flex', alignItems:'center', gap:1, transition:'all 0.2s',
              '&:hover':{ bgcolor:'rgba(255,255,255,0.14)', borderColor:'rgba(255,255,255,0.35)' }
            }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round">
              <path d="M19 12H5M12 5l-7 7 7 7"/>
            </svg>
            <Typography sx={{ fontSize:'0.85rem', fontWeight:600, color:'rgba(255,255,255,0.7)' }}>Volver</Typography>
          </Box>
          <Box component="button" onClick={()=>navigate('/dashboard')}
            sx={{
              height:46, px:3, borderRadius:'12px', border:'none',
              bgcolor:IOS.purple, cursor:'pointer',
              display:'flex', alignItems:'center', gap:1, transition:'all 0.2s',
              boxShadow:`0 6px 20px ${IOS.purple}50`,
              '&:hover':{ filter:'brightness(1.1)', transform:'translateY(-1px)' }
            }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            <Typography sx={{ fontSize:'0.85rem', fontWeight:700, color:'white' }}>Ir al inicio</Typography>
          </Box>
        </Box>

        {/* Línea divisoria */}
        <Box sx={{ mt:6, display:'flex', alignItems:'center', gap:1.5 }}>
          <Box sx={{ flex:1, height:'1px', bgcolor:'rgba(255,255,255,0.08)' }} />
          <Typography sx={{ fontSize:'0.65rem', color:'rgba(255,255,255,0.2)', fontWeight:500 }}>SISTEMA INTEGRA</Typography>
          <Box sx={{ flex:1, height:'1px', bgcolor:'rgba(255,255,255,0.08)' }} />
        </Box>
      </Box>

      {/* Logo ARDATA */}
      <Box sx={{ position:'fixed', bottom:{ xs:12, sm:20 }, right:{ xs:16, sm:24 }, zIndex:10,
        textAlign:'right', display:'flex', flexDirection:'column', alignItems:'flex-end', gap:0.5 }}>
        <img src="/imagenes/logo-ardata.png" alt="ARDATA"
          style={{ width:window.innerWidth<600?65:82, height:'auto', opacity:0.4 }}
          onError={e=>e.target.style.display='none'} />
        <Typography sx={{ fontSize:{ xs:'7px', sm:'8px' }, color:'rgba(255,255,255,0.25)' }}>
          © 2026 ardata, todos los derechos reservados
        </Typography>
      </Box>
    </Box>
  );
};

export default EnConstruccion;
